import {GetterTree} from "vuex";
import {RootState} from "@/store/types";
import {SystemActionsState} from "@/store/user_management/system_actions/types";

export const getters: GetterTree<SystemActionsState, RootState> = {
    systemActions: state => state.systemActions ?? [],
    systemUsersAction: state => state.systemUsersAction ?? [],
}
